import React from 'react';
import Box from '@material-ui/core/Box';
import IngestDataContainerProvider from './IngestDataContainerProvider';
import {SetIngestData} from './IngestDataTypes';

interface IngestDataProps {
    setIngestData: SetIngestData;
    resetIngestData: () => void;
    data: string | null;
    dataFormat: string;
    isEditable: boolean;
    putIngestData: (id: string, jsonData: {[key: string]: any}) => void
}

export default function IngestData(props: IngestDataProps) {
    const {
        setIngestData,
        resetIngestData,
        data,
        dataFormat,
        isEditable,
        putIngestData,
    } = props;

    return (
        <Box>
            <IngestDataContainerProvider
                isEditable={isEditable}
                dataFormat={dataFormat}
                putIngestData={putIngestData}
                setIngestData={setIngestData}
                resetIngestData={resetIngestData}
                data={data}
            />
        </Box>
    );
}
